import React from "react";
import PageNotFoundMain from "./PageNotFoundMain";
export default function PageNotFound() {
  return (
    <div>
      <PageNotFoundMain />
    </div>
  );
}
